import React, {useEffect, useState} from "react";
import {
  Box,
  Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle,
  MenuItem,
  Select,
  Stack,
} from "@mui/material";
import {
  IconTrash, IconUpload,
} from "@tabler/icons-react";
import {ProjectForm} from "../../project-creation/components/ProjectForm";
import Typography from "@mui/material/Typography";
import {grey, lightBlue} from "@mui/material/colors";

export const ProjectUpdateForm = ({
                                    project,
                                    setProject,
                                    languages,
                                    organizations,
                                    asriProjects,
                                    fetchData,
                                    users,
                                    loading,
                                    onDelete
                                  }) => {

  const [addMemberDialog, setAddMemberDialog] = useState(false);

  const updateProject = (key, value) => {
    setProject(prev => ({...prev, [key]: value}))
  }


  return (
    <>
      <AddMemberDialog
        open={addMemberDialog}
        handleClose={() => setAddMemberDialog(false)}
        users={users}
        onSuccess={(newUser) => {
          if (newUser) {
            const team = project?.team || [];
            const uniqueMembers = new Set([...team, newUser]);
            updateProject("team", [...uniqueMembers]);
          }
          setAddMemberDialog(false);
        }}
      />
      <Box sx={{pt: {xs: 2, md: 3}, px: {xs: 2, md: 4}}}>
        <Typography variant={"h4"} fontSize={{xs: "1.25rem", md: "2.125rem"}} fontWeight={600}>Settings</Typography>
      </Box>
      <Box sx={{py: 1}}>
        <ProjectForm setProject={setProject} project={project} languages={languages} organizations={organizations}
                     asriProjects={asriProjects} fetchData={fetchData}/>
      </Box>

      <Stack
        direction={"row"}
        justifyContent={"flex-end"}
        gap={{xs: 1, sm: 2}}
        sx={{
          position: {xs: "sticky", md: "static"},
          bottom: 0,
          zIndex: 2,
          px: {xs: 2, md: 3},
          py: {xs: 1.5, md: 0},
          pb: {md: 3},
          bgcolor: "background.paper",
          borderTop: {xs: 1, md: 0},
          borderColor: "divider",
        }}
      >

        <Button type={"button"} variant={"ghost"} color={"secondary"}
                onClick={onDelete} disabled={loading}
                sx={{bgcolor: grey[100], px: 3, minHeight: {xs: 44, md: "auto"}, flex: {xs: 1, sm: "initial"}, borderRadius: "8px !important", "&:hover": {bgcolor: grey[300],} }}
                startIcon={<IconTrash size={18}/>}>
          Delete
        </Button>
        <Button type={"submit"} variant={"modal"} disabled={loading}
                sx={{minHeight: {xs: 44, md: "auto"}, flex: {xs: 1, sm: "initial"}, px: {xs: 3, md: 1.5}}}
                startIcon={<IconUpload size={18}/>}>
          Save
        </Button>
      </Stack>
    </>
  )
}

const AddMemberDialog = ({open, handleClose, users, onSuccess}) => {
  const [selectedUser, setSelectedUser] = useState(null);

  useEffect(() => {
    if (!open) {
      setSelectedUser(null);
    }
  }, [open])

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        {"Add Member"}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <Select
            labelId="demo-multiple-chip-label"
            id="demo-multiple-chip"
            sx={{flex: 1, m: {xs: 0, sm: 1}, mt: {xs: 1, sm: 1}, width: {xs: "100%", sm: "auto"}, minWidth: {sm: "300px"}}}
            value={selectedUser || ""}
            onChange={e => setSelectedUser(e.target.value)}
          >
            {users.map((name) => (
              <MenuItem
                key={name}
                value={name}
              >
                {name}
              </MenuItem>
            ))}
          </Select>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="ghost" sx={{mr: "auto"}} onClick={handleClose}>Cancel</Button>
        <Button variant="modal" onClick={() => onSuccess(selectedUser)} disabled={selectedUser === null}
                autoFocus>
          Add
        </Button>
      </DialogActions>
    </Dialog>
  )
}
